import Constants from '../../../constants/constants';

const pathType = {
  'single-game': { pathname: 'play_game', searchParams: { single_game_id: 'ALL' }, retainNavbar: true },
  'group-play': { pathname: 'play_game', searchParams: { group_play_id: 1 } },
  'functional-skill': { pathname: 'play_game', searchParams: { functional_skill_session_id: null } },
  intervention: {
    pathname: 'play_game',
    searchParams: { functional_skill_session_id: null, playerId: null, gameId: null },
  },
  'group-activities': { pathname: 'play_game', searchParams: { activity_id: null, activity_type: 'group_activity' } },

  'individual-activities': {
    pathname: 'play_game',
    searchParams: { activity_id: null, activity_type: 'individual_activity' },
  },
  'restorative-group-activities': {
    pathname: 'play_game',
    searchParams: { activity_id: null, groupId: null, activity_type: 'group_activity' },
  },
  'restorative-individual-activities': {
    pathname: 'play_game',
    searchParams: { activity_id: null, groupId: null, activity_type: 'individual_activity' },
  },
  'group-and-concurrent': {
    pathname: 'play_game',
    searchParams: { activity_id: null, activity_type: 'group-and-concurrent' },
  },
  'exercise-videos-for-therapy': {
    pathname: 'play_game',
    searchParams: { activity_id: null, activity_type: 'exercise-videos-for-therapy' },
  },
  'designed-session': { pathname: 'play_game', searchParams: { game_session_id: null } },
  tournament: { pathname: 'play_game', searchParams: { single_game_id: null, tournament_mode: 1 } },
  multiplayer: { pathname: 'play_game', searchParams: { room_code: null } },
  'private-session': { pathname: 'play_game' },
  'out-of-gym-session': { pathname: 'play_game', searchParams: { out_of_gym_session_id: null } },
  'home-play': { pathname: 'play_game', searchParams: { game_session_id: null, home_play: 1 } },
  'home-play-single-game': { pathname: 'play_game', searchParams: { single_game_id: 'ALL', home_play: 1 } },
};

export default function webcorePath(path_type, auth = null, iframe = null, id = null, stateSearchParams = {}) {
  const platformUrl = new URL(window.location.href);
  const origin = Constants.PLAY_CONTENT_URL;
  const url = new URL(origin.startsWith('http') ? origin : `${window.location.protocol}${origin}`);

  if (!path_type) {
    path_type = 'single-game';
  }
  url.pathname = pathType[path_type].pathname;
  let searchParams = { ...pathType[path_type].searchParams };
  if (stateSearchParams) {
    searchParams = { ...searchParams, ...stateSearchParams };
  }
  for (const key in searchParams) {
    searchParams[key] = searchParams[key] === null ? id : searchParams[key];
  }
  if (iframe) {
    searchParams['iframe'] = 1;
  } else {
    searchParams['purl'] = platformUrl.origin;
  }
  if (auth) {
    searchParams['auth'] = auth;
  }
  for (const paramName in searchParams) {
    url.searchParams.append(paramName, searchParams[paramName]);
  }
  return url.href;
}

export function retainNavbar(path_type) {
  if (!path_type) {
    path_type = 'single-game';
  }

  if (!pathType[path_type]) {
    return false;
  }

  return pathType[path_type].retainNavbar || false;
}
